<p>
  Internationalization issues should be solved consistently throughout all applications - there is no necessity to start creative
  achievements in this area.
</p>

<p>Basically, these items are affected by language and locale settings.:</p>
<ul>
  <li>Date & Time</li>
  <li>Number</li>
  <li>Currency</li>
</ul>
<p>
  Please find in the Clarity addons library the definitions and some samples:
  <a href="https://porscheinformatik.github.io/clarity-addons/documentation/latest/internationalization">
    Clarity addons internationalization
  </a>
</p>
